import { LocalStorage } from '../helpers';

import request from './request';
import url from './url';

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

export const getShortLinks = (data) =>
  request(url.getSL, {
    method: 'POST',
    data,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });

export const processLinks = (data) =>
  request(url.processLinks, {
    method: 'POST',
    data,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });

export const getLinks = ({ limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET }) =>
  request(`${url.processLinks}?limit=${limit}&start=${offset}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });

export const getLinksLength = () =>
  request(url.linksLength, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });
